import { render, staticRenderFns } from "./FormImagens.vue?vue&type=template&id=74cd0574&"
import script from "./FormImagens.vue?vue&type=script&lang=js&"
export * from "./FormImagens.vue?vue&type=script&lang=js&"
import style0 from "./FormImagens.vue?vue&type=style&index=0&id=74cd0574&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports